module.exports = {"620821001":"街道","620821100":"城关镇","620821101":"玉都镇","620821102":"高平镇","620821103":"荔堡镇","620821104":"王村镇","620821105":"窑店镇","620821106":"飞云镇","620821107":"丰台镇","620821108":"党原镇","620821109":"汭丰镇","620821110":"太平镇","620821201":"罗汉洞乡","620821202":"泾明乡","620821203":"红河乡","620821400":"温泉经济开发区","620821500":"张老寺农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620821.json
// module id = 2925
// module chunks = 0